import { USERINFO_FAILURE, USERINFO_SUCCESS, USERINFO_REQUEST, USERINFO_DELETE, WEBSESSION_UPDATE, USERINFO_UPDATE, CSA_USER_AUTH, CLEAR_USER_INFO } from "../constants/ActionTypes";

const initialState = {
    loading: false,
    user_details: null,
    web_session_trans_id: null,
    isAuth: false,
    error: null,
    loyalty_details: [],
    ewallet_details: [],
    sales_details: [],
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case USERINFO_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case USERINFO_SUCCESS:
            return {
                ...state,
                // always replacing data
                user_details: action.data.user_detail,
                web_session_trans_id: action.data.user_detail.COM_WEB_SESSION_ID || null,
                loading: false,
                isAuth: true,
                error: null,
            };
        case USERINFO_UPDATE:
            return {
                ...state,
                // always replacing data
                loyalty_details: action.data.loyalty_details,
                ewallet_details: action.data.ewallet_details,
                sales_details: action.data.sales_details,
                user_details: action.data.user_detail,
                loading: false,
                isAuth: true,
                error: null,
            };
        case USERINFO_DELETE:
            return {
                ...state,
                // always replacing data
                user_details: [],
                // loyalty_details: [],
                // ewallet_details: [],
                // sales_details: [],
                web_session_trans_id: null,
                isAuth: false,
                loading: false,
                error: null,
            };
        case CLEAR_USER_INFO:
            return {
                ...state,
                user_details: [],
                // loyalty_details: [],
                // ewallet_details: [],
                // sales_details: [],
            }
        case USERINFO_FAILURE:
            return {
                ...state,
                 loyalty_details: [],
                ewallet_details: [],
                user_details: [],
                sales_details: [],
                loading: false,
                error: action.error,
            };
        case WEBSESSION_UPDATE:
            return {
                ...state,
                web_session_trans_id: action.data.web_session_trans_id,
                loading: false,
            };
        case CSA_USER_AUTH:
            return {
                ...state,
                loading: false,
                isAuth: true,
            }
        default:
            return state;
    }
}
